// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"AlertListByProcessMore_moreButton__2biwL","innerWrapper":"AlertListByProcessMore_innerWrapper__mhzCM","icon":"AlertListByProcessMore_icon__Nga4H"};